import React, { useEffect, useState, useContext } from "react"
import MetaTags from "react-meta-tags"
//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"
import { get, del, post } from "helpers/api_helper"
import ConfirmationModal from "components/Common/Modals/ConfirmationModal"
import { Table, Tbody } from "react-super-responsive-table"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { CustomColumn, CustomRow } from "components/Common/CustomTable"
import { CustomAlertContext } from "utils/context/CustomAlertContext"
import { Pagination } from "components/Common/Pagination"
import { CustomSearch } from "components/Common/CustomSearch"
import { TableRowsHoc } from "components/Common/TableRowsHoc"

const Customers = () => {
  const [customerData, setCustomers] = useState([])
  const [search, setSearch] = useState("")
  const [pagination, setPagination] = useState({ page_no: 1, limit: 20 })

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [deleteData, setDeleteData] = useState(false)
  const customAlert = useContext(CustomAlertContext)
  const [selectedTokens, setSelectedTokens] = useState([])
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [multiDelete, setMultiDelete] = useState(false)
  useEffect(() => {
    getCustomers()
  }, [])
  const getCustomers = (query = pagination) => {
    get("customers", { params: query }).then(res => {
      const { status, result } = res
      let customers = result.data.map((cus, i) => {
        cus.name = (
          <a href={`customers/view/${cus._id}`}>
            {cus.first_name} {cus.last_name || ""}
          </a>
        )
        return cus
      })
      setCustomers(customers)
      setPagination(result.meta_data)
    })
  }

  const toggleModal = () => {
    if (isOpenModal) {
      setDeleteData(false)
    }
    setIsOpenModal(!isOpenModal)
    setMultiDelete(false)
  }

  const openModal = (status, data) => {
    setIsOpenModal(status)
    setDeleteData(data)
  }

  const handleDelete = () => {
    if (multiDelete) {
      post("customer/multi-delete", {
        ids: selectedTokens.map(tokens => tokens._id),
      })
        .then(res => {
          customAlert.notify(res.message)
          setSelectedTokens([])
          getCustomers()
          setIsOpenModal(false)
          setMultiDelete(false)
        })
        .catch(err => console.log(`err`, err))
    } else {
      del(`customers/${deleteData._id}`).then(res => {
        const { status, result } = res
        customAlert.notify(res.message)
        setDeleteData(false)
        setIsOpenModal(false)
        getCustomers()
      })
    }
  }

  const handleCheck =
    (user = false) =>
    event => {
      let tokens = []
      let obj = { _id: user._id, device_id: user.device_id }
      if (user) {
        tokens = [...selectedTokens]
        if (event.target.checked) {
          tokens.push(obj)
        } else {
          let index = tokens.findIndex(i => i._id === user._id)
          if (index > -1) {
            tokens.splice(index, 1) // 2nd parameter means remove one item only
          }
        }
      } else {
        if (event.target.checked) {
          customerData.map((dg, i) =>
            tokens.push({ _id: dg._id, device_id: dg.device_id })
          )
        } else {
          tokens = []
        }
      }

      setSelectedTokens(tokens)
    }
  const getCheckBox = index => user_id => {
    let user = customerData.length
      ? customerData.find(x => x._id === user_id)
      : {}
    return (
      <span>
        <input
          type="checkbox"
          onChange={handleCheck(user)}
          checked={selectedTokens.find(token => token._id === user_id)}
        />{" "}
        {/* {(pagination.page_no - 1) * pagination.limit + index + 1} */}
      </span>
    )
  }
  const getSno = index => user_id => {
    return (
      <span>{(pagination.page_no - 1) * pagination.limit + index + 1}</span>
    )
  }

  const getFields = index => {
    return [
      {
        column: (
          <input
            type="checkbox"
            onChange={handleCheck()}
            checked={
              customerData.length &&
              selectedTokens.length == customerData.length
            }
            className="th-checkbox"
          />
        ),
        key: "_id",
        value: getCheckBox(index),
      },
      {
        column: "S.No.",
        key: "_id",
        value: getSno(index),
      },
      { column: "Name", key: "name" },
      { column: "E-mail", key: "email" },
      {
        column: "Contact Number",
        key: "contact_number",
        value: (cell, row) =>
          (row.country_code ? row.country_code + "-" : "") + row.contact_number,
      },
    ]
  }
  const getRows = () => (
    <TableRowsHoc length={customerData.length}>
      {customerData.map((customer, i) => (
        <CustomRow
          key={customer._id}
          fields={getFields(i)}
          data={customer}
          section={"customers"}
          handleDelete={openModal}
        />
      ))}
    </TableRowsHoc>
  )

  const handleMultiStatus = status => {
    post("customer/multi-change-status", {
      ids: selectedTokens.map(tokens => tokens._id),
      status,
    })
      .then(res => {
        customAlert.notify(res.message)
        setSelectedTokens([])
        getCustomers()
      })
      .catch(err => console.log(`err`, err))
  }

  const handleMultiDelete = () => {
    setMultiDelete(true)
    setIsOpenModal(true)
  }
  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>Customers | GoFetchIt</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumb breadcrumbItem="Customers" />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CustomSearch
                    getData={getCustomers}
                    pagination={pagination}
                    setSearch={setSearch}
                    placeholder={"Name, E-mail"}
                  />
                  <div className="d-flex justify-content-between">
                    {selectedTokens.length ? (
                      <Dropdown
                        isOpen={dropdownOpen}
                        toggle={() => setDropdownOpen(!dropdownOpen)}
                      >
                        <DropdownToggle caret>Action</DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            onClick={() => handleMultiStatus("true")}
                          >
                            Active
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => handleMultiStatus("false")}
                          >
                            Inactive
                          </DropdownItem>
                          <DropdownItem onClick={handleMultiDelete}>
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    ) : (
                      ""
                    )}
                    <Button color="primary" className="mb-2 ml-auto">
                      <a href="/customers/add" style={{ color: "white" }}>
                        Add New
                      </a>{" "}
                    </Button>
                  </div>
                  <div className="text-end"></div>
                  <Table className="table table-striped table-bordered">
                    <CustomColumn fields={getFields()} index={false} />
                    <Tbody>{getRows()}</Tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {pagination.total_pages && pagination.total_pages > 1 ? (
          <Pagination
            pagination={pagination}
            getData={getCustomers}
            search={search}
          />
        ) : null}
      </div>
      <ConfirmationModal
        toggleModal={toggleModal}
        isOpenModal={isOpenModal}
        deleteRecord={handleDelete}
        title={multiDelete ? "Delete Customers" : "Delete Customer"}
      />
    </>
  )
}

export default Customers
